/* eslint-disable jsx-a11y/tabindex-no-positive */
import classnames from 'classnames';
import get from 'lodash/get';
import round from 'lodash/round';
import sum from 'lodash/sum';
import { bool, number, objectOf, string } from 'prop-types';
import React from 'react';
import { Label } from 'reactstrap';

import { countries } from '../../constants';
import ShareInput from '../../generic/ShareInput';
import DerivedCurrencyInput from '../utils/DerivedCurrencyInput';

function renderSum(shareSum, name, total) {
  return (
    <td key="sum" className={classnames({ 'text-warning': shareSum !== 1 })}>
      <DerivedCurrencyInput
        share={shareSum}
        budget={total}
        className="text-nowrap"
        displayType="text"
      />
      <br />
      <ShareInput className="text-nowrap" displayType="text" value={shareSum} />
    </td>
  );
}
function CountrySplit({
  name,
  value,
  total,
  onChange,
  quoteLineId,
  disableAll,
  productCode,
  productOperativeSystem,
}) {
  const countryColumns = countries.map(({ countryCode, label, isDisabled }) => {
    const share = get(value, countryCode, 0);
    const currencyName = `${name}.${countryCode}.absolute`;
    const shareName = `${name}.${countryCode}`;
    return (
      <td key={countryCode}>
        <Label for={currencyName} hidden>
          {label} net share
        </Label>
        <DerivedCurrencyInput
          bsSize="sm"
          id={currencyName}
          name={currencyName}
          share={share}
          budget={total}
          onChange={onChange}
          data-country-code={countryCode}
          data-quote-line-id={quoteLineId}
          readOnly
        />
        <Label for={shareName} hidden>
          {label} share percentage
        </Label>
        <ShareInput
          bsSize="sm"
          className="mt-1"
          id={shareName}
          name={shareName}
          onChange={onChange}
          data-country-code={countryCode}
          data-quote-line-id={quoteLineId}
          value={share}
          readOnly={isDisabled || disableAll}
          tabIndex="4"
        />
      </td>
    );
  });
  const shareSum = round(sum(Object.values(value)), 4);
  const result = [];

  result.push(renderSum(shareSum, name, total));

  // Show country columns for all except zmsAm non-CCP products
  if (productOperativeSystem !== 'zms_am' || productCode.includes('CCP')) {
    result.push(...countryColumns);
  }

  return result;
}

CountrySplit.propTypes = {
  /* { [countryCode]: share }  */
  value: objectOf(number.isRequired).isRequired,
  total: number.isRequired,
  name: string.isRequired,
  quoteLineId: number.isRequired,
  disableAll: bool,
  productCode: string,
  productOperativeSystem: string,
};

CountrySplit.defaultProps = {
  disableAll: false,
  productCode: '',
  productOperativeSystem: '',
};

export default CountrySplit;
